import { Component, ContentChild, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

import { ManipulativeType } from 'app/question/constants/manipulative-type.enum';
import { QuestionAnswerType } from 'app/question/constants/question-answer-type';
import { QuestionChoiceWithCorrectIndicatorModel } from 'app/question/models/question-choice-with-correct-indicator.model';
import * as questionUtils from 'app/question/utils/question-utils';
import { MissionReportQuestionResultsModel } from 'app/teacher/models/mission-report-question-results.model';

@Component({
  selector: 'kh-teacher-question-flex',
  templateUrl: './teacher-question-flex.component.html',
  styleUrls: ['./teacher-question-flex.component.less'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TeacherQuestionFlexComponent {
  public utils = questionUtils;

  @Input() public questionTitle = '';
  @Input() public question!: MissionReportQuestionResultsModel;
  @Input() public questionTextProperty = 'QuestionText';
  @Input() public manipulativeType!: ManipulativeType;
  @Input() public answerType!: QuestionAnswerType;
  @Input() public questionChoices: QuestionChoiceWithCorrectIndicatorModel[] = [];

  @ContentChild('questionTitleLayout') public questionTitleLayout?: TemplateRef<unknown>;
  @ContentChild('questionTextSubstituteLayout') public questionTextSubstituteLayout?: TemplateRef<unknown>;
  @ContentChild('afterQuestionTextLayout') public afterQuestionTextLayout?: TemplateRef<unknown>;
  @ContentChild('answersTitleLayout') public answersTitleLayout?: TemplateRef<unknown>;
  @ContentChild('preAnswersContent') public preAnswersContent?: TemplateRef<unknown>;
  @ContentChild('answersTitleAdditionalContent') public answersTitleAdditionalContent?: TemplateRef<unknown>;
  @ContentChild('choiceRowLayout') public choiceRowLayout?: TemplateRef<unknown>;

  public canShowChoice(choice: QuestionChoiceWithCorrectIndicatorModel): boolean {
    return this.answerType === QuestionAnswerType.OpenAnswer && !choice.IsCorrect;
  }

  public isCorrectChoice(choice: QuestionChoiceWithCorrectIndicatorModel): boolean {
    return !this.question.IsSurveyQuestion && choice.IsCorrect;
  }
}
